import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import DesktopWindowsOutlinedIcon from "@mui/icons-material/DesktopWindowsOutlined";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import "./EventCardLarge.css";

const EventCardLarge = ({ event, page = "reg" }) => {
  const navigate = useNavigate();
  // Interpret `event.offline`: boolean/string/number values
  // User mapping: offline === true  => offline
  //               offline === false => online
  const offlineFlag = event.offline;
  const isOffline =
    offlineFlag === true ||
    offlineFlag === "true" ||
    (typeof offlineFlag === "string" &&
      offlineFlag.toLowerCase() === "offline") ||
    Number(offlineFlag) === 1 ||
    (event.type && event.type.toLowerCase() === "offline");

  const handleRegister = () => {
    navigate(`/events/Reg2/${event.id}`);
  };

  // alias for clearer naming in registration checks
  const storeData = event;

  // Registration / page state
  const isRegPage = page === "reg";
  const isPastPage = page === "past";
  const isCancelledOrCompleted =
    storeData.status === "Cancelled" || storeData.status === "Completed";
  const isRegistrationClosed =
    (typeof storeData.maxParticipants === "number" &&
      typeof storeData.regCount === "number" &&
      storeData.maxParticipants <= storeData.regCount) ||
    storeData.activeForRegistration === false ||
    storeData.openForEveryone === false;

  const showRegister =
    isRegPage &&
    !isPastPage &&
    !isCancelledOrCompleted &&
    !isRegistrationClosed &&
    storeData.status !== "closed";

  const renderStatusBadge = () => {
    if (event.status === "closed" || isRegistrationClosed) {
      return (
        <div
          className="event-status-closed"
          style={{ minHeight: "50px", maxHeight: "50px" }}
        >
          Registration Closed
        </div>
      );
    }

    // Show "Few slots left" when available slots < 500
    const availableSlots = Number(event.slotsAvailable) || 0;
    if (availableSlots > 0 && availableSlots < 10) {
      return (
        <div className="event-availability warning">
          <div className="availability-info">
            <ErrorOutlineOutlinedIcon className="warning-icon" />
            <span>Few slots left</span>
          </div>
          <span className="slot-count">Only {event.slotsAvailable}</span>
        </div>
      );
    }

    return (
      <div
        className="event-availability normal"
        style={{ minHeight: "34px", maxHeight: "34px" }}
      >
        <span className="availability-text">Available slots</span>
        <span className="slot-count">{event.slotsAvailable}</span>
      </div>
    );
  };

  return (
    <div className="event-card-large">
      <div className="event-card-header">
        <span
          className={`event-type-badge ${isOffline ? "offline" : "online"}`}
        >
          {isOffline ? (
            <FmdGoodOutlinedIcon className="type-icon" />
          ) : (
            <DesktopWindowsOutlinedIcon className="type-icon" />
          )}
          {isOffline ? "Offline" : "Online"}
        </span>
      </div>

      <div className="event-card-body">
        <h3 className="event-title">{event.title}</h3>
        <div className="event-divider"></div>
        <div className="event-details">
          <div className="detail-row">
            <div className="detail-item">
              <span className="detail-label">Trainer</span>
              <span className="detail-value">{event.trainer}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Language</span>
              <span className="detail-value">{event.language}</span>
            </div>
          </div>
          <div className="detail-row">
            <div className="detail-item">
              <span className="detail-label">Date</span>
              <span className="detail-value">{event.date}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Time</span>
              <span className="detail-value">{event.time}</span>
            </div>
          </div>
        </div>

        {isOffline && event.place && (
          <div className="event-location">
            <FmdGoodOutlinedIcon
              className="type-icon"
              fontSize="md"
              style={{ color: "#94A3B8" }}
            />
            <div className="location-details">
              <span className="location-place">{event.place}</span>
              <span className="location-address">{event.address}</span>
            </div>
          </div>
        )}
      </div>

      <div className="event-card-footer">
        {renderStatusBadge()}

        {showRegister && (
          <button
            className={`register-btn ${!showRegister ? "disabled" : ""}`}
            onClick={() => showRegister && handleRegister()}
            disabled={!showRegister}
            aria-disabled={!showRegister}
          >
            Register Now
            <ArrowForwardIcon className="btn-icon" />
          </button>
        )}
      </div>
    </div>
  );
};

export default EventCardLarge;
